export default "__VITE_ASSET__Hb$TwKXK__"